// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:defb2904-8c71-4a0e-b348-146194da3c27",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_lci9KWyyi",
    "aws_user_pools_web_client_id": "5i8c6mk3evhtqia64adnngrtm1",
    "oauth": {},
    "aws_user_files_s3_bucket": "myshapes-uploads-master",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://5ghn7aidhnburf6bthx5zwnvau.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "myshapesRestApi",
            "endpoint": "https://7hzir9mygk.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
